import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import "./Upload.css";
import useAuth from './useAuth';
import { BASE_URL } from "./Constants";

const Upload = () => {
  const [departments, setDepartments] = useState([]);
  const [formData, setFormData] = useState({
    department: "",
    empCode: "",
    designation: "",
    band: "",
    name: "",
    image: null,
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useAuth();
  // Fetch profile (authentication check)
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const fetchProfile = async () => {
      try {
        const response = await fetch(`${BASE_URL}profile`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        const data = await response.json();
        console.log("Profile data:", data); // Debugging
      } catch (err) {
        console.error("Error fetching profile:", err);
      }
    };
    fetchProfile();
  }, []);

  // Fetch departments
  useEffect(() => {
    const fetchDepartments = async () => {
      const token = localStorage.getItem("authToken");
      try {
        const response = await fetch(`${BASE_URL}dept`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) throw new Error("Failed to fetch departments");
        const data = await response.json();
        setDepartments(data.departments || []);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
    fetchDepartments();
  }, []);

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle file input change
  const handleFileChange = (e) => {
    setFormData({ ...formData, image: e.target.files[0] });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("authToken");
    const form = new FormData();
    Object.entries(formData).forEach(([key, value]) => form.append(key, value));

    try {
      const response = await fetch(`${BASE_URL}upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: form,
      });
      if (!response.ok) throw new Error("Failed to submit form");
      console.log("Form submitted successfully");
    } catch (err) {
      console.error("Error submitting form:", err);
    }
  };

  return (
    <div className="container-scroller">
      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="col-md-12 grid-margin">
              <h4>Viva Question Details</h4>
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Department</label>
                          <select
                            name="department"
                            className="form-control"
                            onChange={handleInputChange} required
                          >
                            <option value="">Select Department</option>
                            {loading ? (
                              <option>Loading...</option>
                            ) : (
                              departments.map((dept, index) => (
                                <option key={index} value={dept.dept_name}>
                                  {dept.dept_name}
                                </option>
                              ))
                            )}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Question</label>
                          <textarea name="question" id="question" placeholder="Viva Question"
                            
                            className="form-control"
                            value={formData.question}
                            onChange={handleInputChange} required
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Rating</label>
                          <input
                            type="number" placeholder="Rating"  
                            name="rating" id="rating"
                            className="form-control" max="5" min="1"
                            value={formData.rating}
                            onChange={handleInputChange} required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                     
                      
                     
                    </div>
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                    <a href="Preparequestionlist">
                      <button type="button" className="btn btn-danger">Cancel</button></a>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <footer className="footer">
            <span className="text-muted">© {new Date().getFullYear()} Vijaya Diagnostic Centre</span>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default Upload;
